// @flow weak

import React from 'react';

const Footer = () => (
  <div className="footer-main">
    react Director Admin Template
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/footer/Footer.js